import React from 'react';
import ForgetPasswordForm from 'components/authentication/ForgetPasswordForm';
import AuthCardLayout from 'layouts/AuthCardLayout';

const ForgetPassword = () => {
  return (
    <AuthCardLayout>
      <h4 className="mb-0 text-center"> ¿Olvidaste tu contraseña?</h4>
      <p className="mb-0 text-center">
        Ingresa tu correo y te enviaremos un enlace para restablecerlo.
      </p>
      <ForgetPasswordForm layout="card" />
    </AuthCardLayout>
  );
};

export default ForgetPassword;
